import { Actions, ofType } from '@ngrx/effects';
import { createAction } from '@ngrx/store';
import { NEVER, Observable, SchedulerLike, Subject, catchError, switchMap, takeUntil, throwError, timer } from 'rxjs';
import { GrpcStatusEvent } from '@ngx-grpc/common';

const GRPC_STATUS_CODES = {
  PERMISSION_DENIED: 7,
} as const;

function shouldRetryGrpcError(error: any): boolean {
  if (error instanceof GrpcStatusEvent) {
    const statusCode = error.statusCode;

    if (statusCode === GRPC_STATUS_CODES.PERMISSION_DENIED) {
      return false;
    }

    return true;
  }
  return true;
}

export function retryWithDelay<T>(maxRetry: number, delayMs: number, until$?: Actions | Subject<any>, scheduler?: SchedulerLike) {
  let retries = 0;
  return (source: Observable<T>) => {
    return source.pipe(
      catchError((error, caught) => {
        if (!shouldRetryGrpcError(error)) {
          return throwError(() => error);
        }
        if (retries >= Math.min(maxRetry, 10)) {
          return throwError(() => error);
        }
        retries++;
        return timer(delayMs, scheduler).pipe(switchMap(() => caught));
      }),
      takeUntil(until$ instanceof Actions ? until$.pipe(ofType(cancelRetry)) : until$ || NEVER),
    );
  };
}

// To avoid circular dependency between the auth module.
// The auth module will dispatch this action when the user is logged out
export const cancelRetry = createAction(`GRPC Cancel retry`);

/**
 * 专门用于全局请求的重试操作符（如 GetUserDetails）
 * 与 retryWithDelay 的区别：不响应 cancelRetry action，确保全局请求不会被路由导航取消
 *
 * 使用场景：
 * - 应用初始化时的全局请求（如获取用户详情）
 * - 不应该被页面导航取消的请求
 */
export function retryWithDelayForGlobalRequest<T>(maxRetry: number, delayMs: number, scheduler?: SchedulerLike) {
  let retries = 0;
  return (source: Observable<T>) => {
    return source.pipe(
      catchError((error, caught) => {
        if (!shouldRetryGrpcError(error)) {
          return throwError(() => error);
        }
        if (retries >= Math.min(maxRetry, 10)) {
          return throwError(() => error);
        }
        retries++;
        return timer(delayMs, scheduler).pipe(switchMap(() => caught));
        // 注意：这里没有 takeUntil(cancelRetry)，所以不会被路由导航取消
      }),
    );
  };
}
